// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__td63K","consentsList":"PatientConsents_consentsList__rzhWK","consentsListEmpty":"PatientConsents_consentsListEmpty__3EJxt"};